/**
 * @prettier
 */

var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function VariancesWS(viewModel) {
  var self;

  // Predicate this Web Service handler on the Abstract class of a Web
  // Service handler. This establishes core functionality required of
  // these such handlers, which can be overwritten by methods below.
  AbstractWS.apply(this, arguments);

  self = this;
  self.variances = ko.observableArray([]);
  self.name = "VariancesWS";

  /**
   * Defines the string to request API services
   *
   * @method serviceURL
   * @returns {String}
   */
  self.serviceURL = ko.computed(function () {
    var ids = self.parent.selectedQueueIds();

    return "/qless/api/v1/employee/queues/" + ids + "/variances";
  }, self, { deferEvaluation: true });

  /**
   * Overload to prevent service from being called before the QueueID
   * has been set
   *
   * @method doRequest
   * @param {Function} fCallback
   * @returns none
   */
  self.doRequest = function (fCallback) {
    if (self.parent.id !== -1 && self.parent.selectedQueueIds().length > 0) {
      AbstractWS.prototype.doRequest.call(self, fCallback);
    }
  };

  /**
   * Obtains a variance in the collection by the provided session Id
   *
   * @method getVarianceBySessionId
   * @param {String} sessionId
   * @returns {Number | Null}
   */
  self.getVarianceBySessionId = function (sessionId) {
    var variance = 0;

    self.variances().forEach(function (v) {
      if (v.sessionId === sessionId) {
        variance = v.variance;
      }
    });

    return variance;
  };

  /**
   * This method iterates over the data returned from the service and
   * converts the individual nodes into LocationModels and then assigns
   * them to this object's locations collection.
   *
   * @method processData
   * @param {XMLString} xmlData
   * @returns {LocationsWS}
   */
  self.processData = function (xmlData) {
    // Call the superclass method to perform any core actions
    AbstractWS.prototype.processData.call(self, xmlData);

    var json = xmlToJson.parse(xmlData);
    var variances = [];

    if (json) {
      if (json.variances && json.variances.variance) {
        variances = Array.isArray(json.variances.variance)
          ? json.variances.variance
          : [json.variances.variance];
      }
    }

    self.variances(variances);

    return self;
  };

  /**
   * Returns the object to it's initial state
   *
   * @method reset
   * @returns none
   */
  self.reset = function () {
    // Remove any variances
    self.variances.removeAll();

    // Call the superclass method to perform any core actions
    AbstractWS.prototype.reset.call(self);
  };

  return self;
}

VariancesWS.prototype = Object.create(AbstractWS.prototype);
VariancesWS.prototype.constructor = VariancesWS;

module.exports = VariancesWS;
